import React from 'react';
import { Button } from '../ui/button';
import { format, addDays, subDays } from 'date-fns';
import { ChevronLeft, ChevronRight, RefreshCw, CalendarDays, CheckSquare, ImageDown, PanelLeftOpen } from 'lucide-react';

function ScheduleToolbar({ startDate, onDateChange, dates, workCenters, isLoading, onRefresh, onDailySettle, onExport, onOpenSidebar }) {
  const endDate = dates[dates.length - 1];

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 border-b bg-white shrink-0">
      <div className="flex flex-wrap items-center gap-2">
        {onOpenSidebar && (
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden h-8 w-8"
            onClick={onOpenSidebar}
            title="打开待分配工序"
          >
            <PanelLeftOpen className="h-4 w-4" />
          </Button>
        )}
        <h1 className="text-base sm:text-lg font-semibold text-gray-900">生产排程看板</h1>
        <div className="flex flex-wrap items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onDateChange(subDays(startDate, 1))}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <div className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-md text-xs sm:text-sm text-gray-700">
            <CalendarDays className="h-3.5 w-3.5" />
            <span>
              {format(startDate, 'MM/dd')} - {format(endDate, 'MM/dd')}
            </span>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onDateChange(addDays(startDate, 1))}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="h-8 text-xs"
            onClick={() => onDateChange(new Date())}
          >
            今天
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <div className="hidden md:block text-xs text-gray-500">
          设备: {workCenters.length} | 日期: {dates.length}天
        </div>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs px-2 sm:px-3"
          onClick={onRefresh}
          disabled={isLoading}
        >
          <RefreshCw className={`h-3.5 w-3.5 sm:mr-1 ${isLoading ? 'animate-spin' : ''}`} />
          <span className="hidden sm:inline">刷新</span>
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs px-2 sm:px-3"
          onClick={() => onDailySettle(startDate)}
        >
          <CheckSquare className="h-3.5 w-3.5 sm:mr-1" />
          <span className="hidden sm:inline">结算当日</span>
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs px-2 sm:px-3"
          onClick={onExport}
        >
          <ImageDown className="h-3.5 w-3.5 sm:mr-1" />
          <span className="hidden sm:inline">导出图片</span>
        </Button>
      </div>
    </div>
  );
}

export default ScheduleToolbar;
